module.exports = __webpack_public_path__ + "static/media/SkyNet_Birmania.485006c9.png";